import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import vSelect from 'vue-select';

// must be via component
Vue.component('chat-room-header', require('./components/Chat/ChatRoomHeader').default);


Vue.component('broadcast-test-component', require('./components/BroadcastTestComponent.vue').default);
Vue.component('chat-component', require('./components/Chat/ChatComponent.vue').default);
Vue.component('broadcast-component', require('./components/BroadcastComponent.vue').default);
Vue.component('chat-form-component', require('./components/ChatForm.vue').default);
Vue.component('match-game-component', require('./components/MatchGame/MatchGameComponent.vue').default);
Vue.component('members-component', require('./components/Members/MembersComponent.vue').default);
Vue.component('online-card-component', require('./components/Profile/OnlineCardComponent').default);
Vue.component('profile-balance-component', require('./components/Profile/BalanceCardComponent').default);
Vue.component('input-location-component', require('./components/Auth/InputLocation').default);
Vue.component('profile-card-component', require('./components/Members/ProfileCard').default);

Vue.component('notification-component', require('./components/Notification/NotificationComponent.vue').default);
Vue.component('report-modal-component', require('./components/ReportModalComponent').default);
Vue.component('global-component', require('./components/GlobalComponent').default);
Vue.component('chat-unread-messages-component', require('./components/Chat/UnreadMessagesComponent').default);
Vue.component('payment-component', require('./components/PaymentV1/PaymentComponent').default);
Vue.component('payment-banner-component', require('./components/PaymentV1/BannerComponent').default);
Vue.component('payment-last-chance-component', require('./components/PaymentV1/LastChanceComponent').default);
Vue.component('gallery-component', require('./components/Profile/GalleryComponent').default);
Vue.component('app', require('./views/App').default);
Vue.component('home', require('./views/Home').default);
Vue.component('mobile-menu', require('./views/elements/MobileMenu').default);
// Vue.component('verification-status-button', require('./modules/VerificationStatusButton').default);
// Vue.component('verification-status-modal', require('./modules/VerificationStatusModal').default);
Vue.component('user-card-component', require('./components/Profile/UserCardComponent').default);
Vue.component('error-component', require('../front/components/ErrorComponent').default);
Vue.component('user-edit-component', require('./components/User/UserEditComponent').default);

//Vee Validate
Vue.component('validation-observer', ValidationObserver);
Vue.component('validation-provider', ValidationProvider);

// Auth
Vue.component('auth-card', require('./components/Auth/Card.vue').default);

// Vue Select
Vue.component('v-select', vSelect);

// Tests
Vue.component('test-notifications', require('./components/Test/Notifications').default);
Vue.component('test-match-game-cards', require('./components/Test/MatchGameCards').default);
Vue.component('test-register-cards', require('./components/Test/RegisterCards').default);
Vue.component('test-modals', require('./components/Test/Modals').default);
